import { intlTag, type Locale } from '@/shared/i18n'

const RELATIVE_STEPS: Array<{ unit: Intl.RelativeTimeFormatUnit; seconds: number }> = [
  { unit: 'day', seconds: 86400 },
  { unit: 'hour', seconds: 3600 },
  { unit: 'minute', seconds: 60 },
]

// Beyond a week an absolute date is clearer than a rounded relative phrase.
export function relativeTime(iso: string, locale: Locale): string {
  const then = new Date(iso)
  if (Number.isNaN(then.getTime())) return ''
  const tag = intlTag(locale)
  const diffSeconds = Math.round((then.getTime() - Date.now()) / 1000)
  const absSeconds = Math.abs(diffSeconds)
  if (absSeconds >= 86400 * 7 || typeof Intl.RelativeTimeFormat !== 'function') {
    return then.toLocaleDateString(tag, { day: 'numeric', month: 'short', year: 'numeric' })
  }
  const rtf = new Intl.RelativeTimeFormat(tag, { numeric: 'auto', style: 'short' })
  for (const { unit, seconds } of RELATIVE_STEPS) {
    if (absSeconds >= seconds) return rtf.format(Math.round(diffSeconds / seconds), unit)
  }
  return rtf.format(0, 'second')
}
